<template>
  <transition name="fade-transform"
              mode="out-in">
    <router-view :userData="userData" />
  </transition>
</template>

<script>
export default {
  name: "index",
  computed: {
    userData () {
      return this.$store.state.user.userInfo
    }
  }
}
</script>

<style scoped></style>